import { Spin } from 'antd';

interface LoadingSpinnerProps {
  tip?: string;
  fullScreen?: boolean;
}

/**
 * Reusable loading spinner component
 */
export const LoadingSpinner = ({ tip = 'Loading...', fullScreen = false }: LoadingSpinnerProps) => {
  const style = fullScreen
    ? {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100%',
      }
    : {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 48,
      };

  return (
    <div style={style}>
      <Spin size="large" tip={tip} />
    </div>
  );
};

export default LoadingSpinner;
